import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import {
  selectPets,
  selectIndexOfFirstActivePet,
} from 'src/reducers/signup/user';

import getPetId from './getPetId';
import { PATH_SIGNUP_PETS } from '@farmersdog/constants/paths';

/**
 * Get the petId based on the current url and pets in the signup reducer
 */
function useSignupPetLocation() {
  const activeIndex = useSelector(selectIndexOfFirstActivePet);
  const pets = useSelector(selectPets);
  const match = useRouteMatch(`${PATH_SIGNUP_PETS}/:petName`);
  const petName = match?.params.petName;
  return getPetId(petName, pets, activeIndex);
}

export default useSignupPetLocation;
